import React from "react";
import { FaPhoneAlt, FaMapMarkerAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { ADDRESS, CONTACT, EMAIL } from "../../utils/constant";

const Nav = () => {
  return (
    <div className="bg-indigo-800 text-white py-2 px-4">
      <div className="md:flex-row flex-col gap-2 flex items-center justify-between">
        <div className="sm:flex-row flex-col  flex gap-2 sm:gap-5">
          <div className="flex items-center gap-2 text-[12px] hover:text-yellow-500 duration-100 font-[500]">
            <FaPhoneAlt />
            <a href={`tel:${CONTACT}`} className="block">
              +91-{CONTACT}
            </a>
          </div>

          <div className="flex items-center gap-2 text-[12px] hover:text-yellow-500 duration-100 font-[500]">
            <MdEmail />
            <a href={`mailto:${EMAIL}`} className="block">
              {EMAIL}
            </a>
          </div>
        </div>
        <div className="flex items-center gap-2 text-[12px] hover:text-yellow-500 duration-100 font-[500]">
          <FaMapMarkerAlt />
          <a href={`https://share.google/yROviSmmR2pm1JNkx`} target="_blank" className="block">
            {ADDRESS}
          </a>
        </div>
      </div>
    </div>
  );
};

export default Nav;
